export type ExcursionKey =
  | "nice-monaco"
  | "cannes-gourdon"
  | "antibes-juan-les-pins"
  | "saint-tropez"
  | "riviera-italienne"
  | "verdon"
  | "eze-la-turbie"
  | "saint-paul-de-vence";

export type ExcursionHero = {
  title: string;
  subtitle?: string;
  ctaPrimaryHref: string;
  ctaPrimaryLabel: string;
  ctaSecondaryHref?: string;
  ctaSecondaryLabel?: string;
  imageSrc?: string;
  imageAlt?: string;
  image?: import("next/image").StaticImageData;
};

export type ExcursionSection = {
  heading?: string;
  subheading?: string;
  paragraphs?: string[];
  bullets?: string[];
  imageSrc?: string;
  imageAlt?: string;
};

export type ExcursionPage = {
  slug: ExcursionKey;
  hero: ExcursionHero;
  seo?: {
    title: string;
    description: string;
    canonical: string;
  };
  benefits?: { title: string; items: string[] };
  services?: { title: string; items: string[] };
  locations?: { title: string; items: string[] };
  generic?: ExcursionSection;
  showcase?: {
    title?: string;
    cards: { title: string; text: string; tags?: string[] }[];
  };
  highlights?: { title: string; items: { icon?: string; text: string }[] };
  itinerary?: {
    title: string;
    steps: { title: string; description?: string }[];
  };
  practical?: { title: string; items: { label: string; value: string }[] };
  faq?: { question: string; answer: string }[];
  relatedLinks?: { label: string; href: string }[];
};

import { excursionPages } from "./slugs";

export const excursions: ExcursionPage[] = excursionPages;

export const excursionSlugs: ExcursionKey[] = [
  "nice-monaco",
  "cannes-gourdon",
  "antibes-juan-les-pins",
  "saint-tropez",
  "riviera-italienne",
  "verdon",
  "eze-la-turbie",
  "saint-paul-de-vence",
];

export const getExcursionPage = (slug: string): ExcursionPage | undefined =>
  excursions.find((e) => e.slug === (slug as ExcursionKey));

// Cards data used by landing ExcursionsSection (centralized to avoid duplicates)
import type { StaticImageData } from "next/image";
import antibes from "@/assets/images/excursions/destinations/antibes.webp";
import gourdon from "@/assets/images/excursions/destinations/cannes.webp";
import menton from "@/assets/images/excursions/destinations/menton.webp";
import monaco from "@/assets/images/excursions/destinations/monaco.webp";
import verdon from "@/assets/images/excursions/destinations/verdon.webp";
import sttrop from "@/assets/images/excursions/destinations/st-trop.webp";
import stpaulvence from "@/assets/images/excursions/destinations/st-paul-vence.jpeg";
import laturbie from "@/assets/images/excursions/destinations/laturbie.jpeg";

export type ExcursionCard = {
  title: string;
  href: string;
  image: StaticImageData;
};

export const excursionsCards: ExcursionCard[] = [
  { title: "Nice, Monaco", href: "/excursions/nice-monaco", image: monaco },
  {
    title: "Cannes, Gourdon",
    href: "/excursions/cannes-gourdon",
    image: gourdon,
  },
  {
    title: "Antibes, Juan les Pins",
    href: "/excursions/antibes-juan-les-pins",
    image: antibes,
  },
  { title: "Saint‑Tropez", href: "/excursions/saint-tropez", image: sttrop },
  {
    title: "Menton, Riviera Italienne",
    href: "/excursions/riviera-italienne",
    image: menton,
  },
  {
    title: "Lac de St‑Cassien, Gorges du Verdon",
    href: "/excursions/verdon",
    image: verdon,
  },
  {
    title: "Èze, La Turbie",
    href: "/excursions/eze-la-turbie",
    image: laturbie,
  },
  {
    title: "Saint‑Paul‑de‑Vence",
    href: "/excursions/saint-paul-de-vence",
    image: stpaulvence,
  },
];
